import classNames from 'classnames';
import React, { FC, ReactNode } from 'react';
import styles from './styles.module.scss';

interface RadioWithTitleProps {
  children: ReactNode;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  checked: boolean;
  name: string;
  reverse?: boolean;
  className?: string;
  classNameTitle?: string;
  size?: 'medium';
}

const RadioWithTitle: FC<RadioWithTitleProps> = ({
  children,
  onChange,
  checked,
  name,
  reverse = false,
  className,
  classNameTitle,
  size,
}) => {
  return (
    <label
      className={classNames(styles.radio, className, {
        [styles.reverse]: reverse,
        [styles.medium]: size === 'medium',
      })}
      itemScope
      itemType='https://schema.org/Property'
    >
      <input
        name={name}
        type={'radio'}
        onChange={onChange}
        value={checked ? 'true' : 'false'}
        checked={checked}
      />
      <div className={classNames(styles.title, classNameTitle)}>
        <span>{children}</span>
      </div>
    </label>
  );
};

export default RadioWithTitle;
